import React from "react";
import uuid from "uuid";
import styled from 'styled-components';
import isEmpty from "lodash/isEmpty";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

import Cookie from "../../util/Cookie";
import {fetchData,removeData,showToast} from "../../store/action";
import { emailRegex } from "../../util/regExp";
import MediaUpload from "../../components/mediaUpload";
import PrimaryButton from "../../components/buttons/PrimaryButton";
import config from "../../Config";
import {event} from "../../components/reactGA";
import i18n from "../../i18n";

const Container = styled.div`
	background-color: #fff;
    margin-top: 10px;
    overflow-x: hidden;
`;

const SubmitButtonBox = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 15px;
`;

const FormId = "personal-info-from";

const styles = theme => ({
  	textField: {
    	marginBottom: `${theme.spacing.unit*2}px`,
    	fontFamily: 'montserratRegular'
  	}
});


class PersonalInfo extends React.Component{

	constructor(props) {
        super(props);
        this.state = { 
        	submitBtnStatus: false,
        	name: "",
        	email: "",
        	contactNumber: "",
        	shippingAddress: ""
        };
        this.loadData = this.loadData.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.handleImageChange = this.handleImageChange.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
    }

    componentWillMount(){
        this.loadData();
    }

    componentWillUnmount(){
        const {removeData,uniqueId} = this.props;
        removeData({
            uniqueId
        });
    }

    loadData(){
    	const { fetchData, uniqueId } = this.props;
        fetchData({
            uniqueId,
            noLoading: true,
            method:'GET',
            uri: `/userProfile`,
            onSuccess:(freshUser)=>{
                if(!freshUser.contactNumber){
                    const userId = Cookie.get("X-Reycreo-Id");
                    const msisdn = userId.split("BW_PH");
                    freshUser.contactNumber = !isEmpty(msisdn[1]) && msisdn[1];
                } 
                this.setState({...freshUser});
            }
        });
    }

    handleImageChange(file){
        const { email, contactNumber, shippingAddress, name } = this.state;
        let submitBtnStatus = false;
        if(name && email && contactNumber && shippingAddress && emailRegex.email.test(email)){
            submitBtnStatus = true;
        }
        this.setState({file, submitBtnStatus})
    }

    onInputChange(fieldName, value, invalidEmail){
        let newStateData = {...this.state, [fieldName]: value};
        const { email, contactNumber, shippingAddress, name } = newStateData;
        let submitBtnStatus = false;
        if(name && email && contactNumber && shippingAddress && emailRegex.email.test(email)){
            submitBtnStatus = true;
        }
        this.setState({ 
            [fieldName]: value,
            submitBtnStatus,
            invalidEmail,
        })
    }


    onSubmit(e){
        e.preventDefault();
        const { fetchData, showToast, t } = this.props;
        const { submitBtnStatus, shippingAddress, contactNumber, email, name, file } = this.state;
        if(submitBtnStatus) {
            let formData;

            if(file){
                formData = new FormData();
                formData.append('file',file.fileData)
            }

            fetchData({
                method:'POST',
                headers: {'content-type': 'multipart/form-data'},
                uri: `/updateUserProfile`,
                params: {
                    dto:{
                        shippingAddress, 
                        contactNumber, 
                        email, 
                        name 
                    }
                },
                body: formData,
                onSuccess: (res)=> {
                    showToast({
                        text: t("UpdateProfile"),
                        variant: "success",
                    });
                    // this.setState({file: null, submitBtnStatus: false})
                }
            });
            
            event({
                category:"My Account Page",
                action: "Submit Profile"
            });
        }
    }

	render(){
		const { data, t, classes } = this.props;
        const { name, contactNumber, shippingAddress, email, imageUrl, submitBtnStatus, invalidEmail } = this.state;
        if (!data) {
            return null;
        } else if (data.error) {
            return <span>{data.error}</span>
        }
        
		return <Container>
			<form id={FormId} style={{margin: "10px 30px"}} onSubmit={this.onSubmit}>
				<MediaUpload 
                    label={"Upload Pic"}
                    data={{file: imageUrl || `${config.MRBIDNWIN_S3_IMAGE_URL}/ic_profile.png`}}
                    onChange={this.handleImageChange}
                    maxSize={2097152}
                />
		        <TextField
		        	fullWidth
                    id="Name"
                    label={t("FullName")}
                    placeholder={t("FullNamePlaceHolder")}
                    type="text"
                    value={name || ""}
                    onChange={(e) => {
                        this.onInputChange("name", e.target.value)
                    }}
                    data-required={true}
                    className={classes.textField}
                />
                <TextField
                	fullWidth
                    id="Email"
                    error={invalidEmail}
                    label={t("Email")}
                    type="text"
                    placeholder={t("EmailPlaceHolder")}
                    value={email || ""}
                    onChange={(e) => {
                        this.onInputChange("email", e.target.value, !emailRegex.email.test(e.target.value))
                    }}
                    data-required={true}
                helperText={invalidEmail && <span style={{color: 'red'}}>{i18n.t("InvalidEmailAddress")}}</span>}
                    className={classes.textField}
                />
                <TextField
                	fullWidth
                    id="Phone"
                    label={t("PhoneNumber")}
                    type="number"
                    placeholder={t("PhoneNumberPlaceHolder")}
                    value={contactNumber || ""}
                    onChange={(e) => {
                        this.onInputChange("contactNumber", e.target.value, emailRegex.email.test(e.target.value))
                    }}
                    data-required={true}
                    className={classes.textField}
                />
                <TextField
                	fullWidth
                    id="Shipping Address"
                    label={t("ShippingAddress")}
                    type="text"
                    placeholder={t("ShippingAddressPlaceHolder")}
                    value={shippingAddress || ""}
                    onChange={(e) => {
                        this.onInputChange("shippingAddress", e.target.value)
                    }}
                    data-required={true}
                    multiline={true}
          			rows="4"
                    className={classes.textField}
                />
                <SubmitButtonBox>
                    <PrimaryButton 
                        style={{
                            marginBottom: 10,
                            width: '75%',
                            color: '#fff',
                            height: 54,
                            border: 'none',
                            backgroundColor: submitBtnStatus ? "#f32c2c" : "#808080c9" ,
                        }}
                        label="Submit"
                        type="submit"
                        formId={FormId}
                        disabled={!submitBtnStatus}
                    />
                </SubmitButtonBox>
			</form>
		</Container>
	}
}

PersonalInfo = connect((state, ownProps) => {
    let mapStateToProps = {};
    if (state.data && state.data[ownProps.uniqueId]) {
        mapStateToProps.data = state.data[ownProps.uniqueId];
    }
    return mapStateToProps;

}, {
    fetchData,
    removeData,
    showToast,
})((withRouter(withStyles(styles)(PersonalInfo))));

export default class PersonalInfoWrapper extends React.Component {
    componentWillMount() {
        this.uuid = uuid.v4();
    }

    render() {
        return <PersonalInfo {...this.props} uniqueId={this.uuid}/>
    }
}



// WEBPACK FOOTER //
// ./src/views/MyAccount/PersonalInfo.js